import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.setup').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.setuproles, {
    url: '/roles',
    params: { title: 'Setup - Roles' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: 'setupRolesController',
        templateUrl:
          'Client/runner.setup/runner.setup.roles/runner.setup.roles.tmpl.html'
      }
    }
  });
}
